import { PaymentAPI as r } from "./paymentApi.js";
import { PaymentGatewayError as _ } from "./paymentGatewayError.js";
import { PaymentRequests as I } from "./paymentRequests.js";
function C(t) {
  return new Promise((s) => {
    setTimeout(s, t);
  });
}
function R(t, s, h) {
  return window.PaymentRequest ? new PaymentRequest(t, {
    total: {
      label: "Total",
      amount: {
        currency: h,
        value: s.toString()
      }
    }
  }).canMakePayment() : Promise.resolve(!1);
}
function D() {
  if (typeof navigator > "u")
    return !1;
  const { userAgentData: t } = navigator;
  if (t != null && t.platform)
    return t.platform.toLowerCase().includes("android");
  const s = (navigator.userAgent || "").toLowerCase();
  return /android/.test(s);
}
var y;
((t) => {
  function s(e, a) {
    return R(
      [
        {
          supportedMethods: "https://google.com/pay",
          data: {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
              {
                type: "CARD",
                parameters: {
                  allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                  allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "MIR", "VISA"]
                }
              }
            ]
          }
        },
        { supportedMethods: "basic-card" }
      ],
      e,
      a
    ).then((l) => l || D());
  }
  t.isGPayAvailable = s;
  function h(e, a) {
    return R([
      { supportedMethods: "https://apple.com/apple-pay" }
    ], e, a);
  }
  t.isApplePayAvailable = h;
  async function E(e, a, i) {
    const o = [], l = [];
    for (let u = 0; u < e.length; u += 1) {
      const c = e[u], [f, n] = c;
      if (!r.NOT_ALLOWED_METHODS.filter((d) => d[0] === f || d[0] === void 0).some((d) => d[1] === n)) {
        if (n === r.PaymentMethodType.GOOGLE_PAY) {
          l.push(
            t.isGPayAvailable(a, i).then((d) => {
              d && o.push(c);
            })
          );
          continue;
        }
        if (n === r.PaymentMethodType.APPLE_PAY) {
          l.push(
            t.isApplePayAvailable(a, i).then((d) => {
              d && o.push(c);
            })
          );
          continue;
        }
        o.push(c);
      }
    }
    return await Promise.all(l), o;
  }
  t.filterAvailablePaymentMethods = E;
  function p(e) {
    return r.THIRD_PARTY_METHODS.includes(e);
  }
  t.isThirdPartyMethod = p, { engineToString: t.engineToString } = r;
  function M(e) {
    return r.PaymentMethodType[e].toLowerCase().replace(/_/g, "-");
  }
  t.toMethodSlug = M;
  function g(e) {
    return r.PaymentMethodEngine[e].toLowerCase().replace(/_/g, "-");
  }
  t.toEngineSlug = g;
  function m(e) {
    return r.REDIRECT_ENGINES.includes(e);
  }
  t.isRedirectEngine = m;
  function P(e) {
    return e instanceof _ && e.code === r.ERROR_CODE_ORDER_ALREADY_PAID;
  }
  t.isOrderAlreadyPaidError = P;
  function w(e) {
    const a = e.get(r.REDIRECT_ENGINE_PARAM_ORDER_ID), i = e.get(r.REDIRECT_ENGINE_PARAM_ENGINE), o = Number(i);
    return a === null || i === null || r.PaymentMethodEngine[o] === void 0 ? null : { orderId: a, engineType: o };
  }
  t.getRedirectReturn = w;
  async function v(e) {
    const a = e.maxAttempts ?? 15, i = e.intervalMs ?? 2e3, o = e.maxIntervalMs ?? 16e3, { engineType: l } = e, u = new I.PaymentRespository(
      e.gatewayUrl,
      e.gatewayToken
    );
    async function c(f) {
      let n = null;
      try {
        n = await u.validatePaymentTransaction({
          shopOrderId: e.orderId,
          wsUuid: e.wssUuid,
          engineType: l
        });
      } catch {
      }
      if ((n == null ? void 0 : n.action) === 2)
        throw new Error("Payment failed");
      if ((n == null ? void 0 : n.action) === 1)
        return {
          action: n.action,
          code: n.code,
          transactionId: n.transaction_id,
          trackingUrl: n.tracking_url
        };
      if (f + 1 >= a)
        throw new Error("Timed out waiting for the payment to settle");
      const A = Math.min(i * 2 ** f, o);
      return await C(A), c(f + 1);
    }
    return c(0);
  }
  t.verifyRedirectPaymentReturn = v;
})(y || (y = {}));
export {
  y as PaymentUtils
};
//# sourceMappingURL=paymentUtils.js.map
